import React from "react";
import { isButtonGroup } from "../modules/fabricFunctionssec";

const EditBlock = ({
  canvasBg, setCanvasBg, selectedObj,
  textProps, setTextProps, buttonProps, setButtonProps,
  updateAll,
  onSmartSend,
  lineConfig, setLineConfig,
  savedUserId,
  onUndo, canUndo, onRedo, canRedo,
  flexAltText, setFlexAltText,
  messageComposerUI,
  onPreview,
}) => {
  
  const labelStyle = { display: "block", color: "#aaa", fontSize: 13, marginBottom: 6, marginTop: 15, fontWeight: "bold" };

  const ColorPickerRow = ({ label, colorValue, onChange }) => (
    <>
      <label style={labelStyle}>{label}</label>
      <div style={{ display: "flex", gap: 10, alignItems: "center" }}>
        <input type="color" value={colorValue} onChange={onChange} style={{ flex: 1, height: 40, cursor: "pointer" }} />
        <span style={{ fontSize: 13, color: "#888", width: 65, textAlign: "right", fontFamily: "monospace" }}>{colorValue}</span>
      </div>
    </>
  );

  const actionBtnStyle = (disabled) => ({
    flex: 1, padding: "8px", background: disabled ? "#2a2a2a" : "#444", color: disabled ? "#666" : "#fff",
    border: "1px solid", borderColor: disabled ? "#333" : "#555", borderRadius: 6, cursor: disabled ? "not-allowed" : "pointer",
    fontSize: 13, display: "flex", alignItems: "center", justifyContent: "center", gap: 5, transition: "all 0.2s"
  });

  return (
    <div style={{ 
      flex: 1,
      minHeight: 0,
      width: "100%",
      padding: 20, 
      border: "1px solid var(--border-color)", 
      borderRadius: 12,
      background: "var(--bg-panel)", 
      color: "var(--text-primary)", 
      display: "flex", 
      flexDirection: "column", 
      overflow: "hidden"
    }}>
      
      {/* 內層容器負責捲動 */}
      <div style={{ overflowY: "auto", flex: 1, minHeight: 0, paddingRight: 5 }}>
        
        <h3 style={{ fontSize: 16, borderBottom: "1px solid #333", paddingBottom: 12, marginBottom: 10, color: "#fff" }}>屬性設定</h3>

        {/* Undo / Redo */}
        <div style={{ display: "flex", gap: 10, marginBottom: 10 }}>
          <button style={actionBtnStyle(!canUndo)} onClick={onUndo} disabled={!canUndo} title="Ctrl + Z"><span>↩</span> 復原</button>
          <button style={actionBtnStyle(!canRedo)} onClick={onRedo} disabled={!canRedo} title="Ctrl + Shift + Z"><span>↪</span> 重做</button>
        </div>

        <ColorPickerRow label="編輯區背景色：" colorValue={canvasBg} onChange={(e) => setCanvasBg(e.target.value)} />

        {!selectedObj && (
          <div style={{ marginTop: 30, padding: 20, background: "#252525", borderRadius: 8, textAlign: "center", color: "#666", fontSize: 13, border: "1px dashed #444" }}>
            👈 請點擊左側畫布<br/>選取文字或按鈕以編輯
          </div>
        )}

        {(selectedObj?.type === "text" || selectedObj?.type === "textbox") && !isButtonGroup(selectedObj) && (
          <div style={{ animation: "fadeIn 0.3s" }}>
            <label style={labelStyle}>文字內容：</label>
            <textarea rows={3} value={textProps.text} onChange={(e) => setTextProps({ ...textProps, text: e.target.value })} style={{ width: "100%", resize: "vertical" }} />
            <ColorPickerRow label="文字顏色：" colorValue={textProps.color} onChange={(e) => setTextProps({ ...textProps, color: e.target.value })} />
            <label style={labelStyle}>文字大小 (px)：</label>
            <input type="number" value={textProps.fontSize} onChange={(e) => setTextProps({ ...textProps, fontSize: Number(e.target.value) })} />
            <label style={labelStyle}>字體：</label>
            <select value={textProps.fontFamily} onChange={(e) => setTextProps({ ...textProps, fontFamily: e.target.value })} style={{ height: 40 }}>
              <option value="Microsoft JhengHei">微軟正黑體</option>
              <option value="Noto Sans TC">Noto Sans TC</option>
              <option value="Arial">Arial</option>
              <option value="Roboto">Roboto</option>
            </select>
          </div>
        )}

        {selectedObj && isButtonGroup(selectedObj) && (
          <div style={{ animation: "fadeIn 0.3s" }}>
            <label style={labelStyle}>按鈕文字：</label>
            <input type="text" value={buttonProps.text} onChange={(e) => setButtonProps({ ...buttonProps, text: e.target.value })} />
            <ColorPickerRow label="文字顏色：" colorValue={buttonProps.textColor} onChange={(e) => setButtonProps({ ...buttonProps, textColor: e.target.value })} />
            <ColorPickerRow label="按鈕背景色：" colorValue={buttonProps.bgColor} onChange={(e) => setButtonProps({ ...buttonProps, bgColor: e.target.value })} />
            <label style={labelStyle}>文字大小 (px)：</label>
            <input type="number" value={buttonProps.fontSize} onChange={(e) => setButtonProps({ ...buttonProps, fontSize: Number(e.target.value) })} />
            <label style={labelStyle}>連結 (URL)：</label>
            <input type="text" value={buttonProps.linkUrl} onChange={(e) => setButtonProps({ ...buttonProps, linkUrl: e.target.value })} placeholder="https://..." />
          </div>
        )}

        <div style={{ marginTop: 30, display: "flex", flexDirection: "column", gap: 12 }}>
          
          <div style={{ background: "#111827", padding: 12, borderRadius: 8, border: "1px solid #1f2937" }}>
            <div style={{ fontSize: 13, color: "#fff", marginBottom: 8, fontWeight: "bold" }}>推播訊息設定</div>
            <input
              type="text"
              value={flexAltText}
              onChange={(e) => setFlexAltText(e.target.value)}
              style={{ width: "100%", padding: 8, background: "#0f172a", border: "1px solid #1f2937", color: "#fff", borderRadius: 6, fontSize: 13 }}
              placeholder="Flex Message"
            />
          </div>

          {messageComposerUI}
          
          <div style={{ background: "#252525", padding: 12, borderRadius: 8, border: "1px solid #333" }}>
            <div style={{ fontSize: 13, color: "#fff", marginBottom: 8, fontWeight: "bold" }}>發送設定</div>
            <div style={{ display: "flex", gap: 8, marginBottom: 10 }}>
              <button
                type="button"
                onClick={() => setLineConfig({ ...lineConfig, sendMode: "test" })}
                style={{
                  flex: 1,
                  padding: "10px",
                  background: lineConfig.sendMode === "test" ? "var(--accent-color)" : "#333",
                  color: "#fff",
                  border: lineConfig.sendMode === "test" ? "1px solid var(--accent-color)" : "1px solid #555",
                  borderRadius: 6,
                  fontSize: 13,
                  cursor: "pointer",
                }}
              >
                測試
              </button>
              <button
                type="button"
                onClick={() => setLineConfig({ ...lineConfig, sendMode: "broadcast" })}
                style={{
                  flex: 1,
                  padding: "10px",
                  background: lineConfig.sendMode === "broadcast" ? "var(--accent-color)" : "#333",
                  color: "#fff",
                  border: lineConfig.sendMode === "broadcast" ? "1px solid var(--accent-color)" : "1px solid #555",
                  borderRadius: 6,
                  fontSize: 13,
                  cursor: "pointer",
                }}
              >
                全體發送
              </button>
            </div>
            {lineConfig.sendMode === "test" && (
              <div style={{ color: savedUserId ? "#9ca3af" : "#f59e0b", fontSize: 12, marginTop: 4 }}>
                {savedUserId
                  ? `將發送至設定中儲存的 User ID`
                  : "請至設定填寫測試帳號 ID"}
              </div>
            )}
            {lineConfig.sendMode === "broadcast" && (
              <div style={{ color: "#f59e0b", fontSize: 12, marginTop: 4 }}>
                將發送給官方帳號所有好友
              </div>
            )}
          </div>
        </div>
      </div>
      
      {/* 底部固定按鈕 */}
      <div style={{ marginTop: 10, paddingTop: 10, borderTop: "1px solid #333", display: "flex", flexDirection: "column", gap: 8, flexShrink: 0 }}>
        <button style={{ padding: "12px", background: "#444", color: "#fff", border: "none", borderRadius: 6, cursor: "pointer", fontWeight: "bold" }} onClick={updateAll}>
          ⟳ 更新畫布預覽
        </button>

        <button style={{ padding: "12px", background: "var(--accent-color)", color: "#fff", border: "none", borderRadius: 6, cursor: "pointer", fontWeight: "bold", boxShadow: "0 4px 12px rgba(59, 130, 246, 0.3)" }} 
          onClick={onSmartSend}
        >
          🚀 上傳並發送
        </button>
      </div>

      <style>{`@keyframes fadeIn { from { opacity: 0; transform: translateY(5px); } to { opacity: 1; transform: translateY(0); } }`}</style>
    </div>
  );
};

export default EditBlock;